import { render, staticRenderFns } from "./DeliveryStatusMarker.vue?vue&type=template&id=4022e7a6&scoped=true&"
import script from "./DeliveryStatusMarker.vue?vue&type=script&lang=js&"
export * from "./DeliveryStatusMarker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4022e7a6",
  null
  
)

export default component.exports